<template>
  <div id="app">
    
    <div class="auth-anime">
      <h2>Вход</h2>
      <div class="auth-block">
        
        <div class="auth-form">
          <label>Логин</label>
          <input class="login" type="text" name="login" @keyup.enter="auth">
          <label>Пароль</label>
          <input class="password" type="password" name="password" @keyup.enter="auth">
          <div>
            <button class="signin-button" @click="auth">Вход</button>
            <router-link to="/register">
              <button>Регистрация</button>
            </router-link>
          </div>
          <router-link to="/forgot" :style="{'display':'block','width':'125px','color':'#0d6efd !important'}">
            <p>Забыли пароль?</p>
          </router-link>
          
          
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";



export default {
  data() {
    return {
      urlBasic: "",
      
    };
  },
  created(){
    this.auth_hash();
    
  },
  mounted(){
    window.YaSendSuggestToken("https://anione.fun", {
      "kek": true
    });
    
  },
  updated(){
    
  },
  methods: {
    auth: function(){
      let login = document.querySelector('.login').value;
      let password = document.querySelector('.password').value;
      let url = `${window.location.protocol}//${window.location.hostname}/api/signin.php?username=${login}&password=${password}`;
      
      

      axios
      .get(url)
      .then((response) => {
        if(response.data){
          console.log(response.data);
          //alert(response.data[0].username);
          localStorage.setItem('user_id', response.data[0].id);
          localStorage.setItem('password_hash', response.data[0].password_hash);
          localStorage.setItem('username', response.data[0].username);
          window.location.pathname = '/cabinet/favorite';
        }else{
          alert('Такого логина или пароля нету =(');
          console.log('Не верный логин или пароль: ' + response.data);
        }
        
      })
      .catch((error) => {
        console.error(error);
      });
    },
    auth_hash: function(){
      
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        console.log('asd');
        let url = `${window.location.protocol}//${window.location.hostname}/api/signin.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;

        axios
        .get(url)
        .then((response) => {
          if(response.data){
            console.log(response.data);
          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
          
        })
        .catch((error) => {
          alert('Срок сессии истек. Авторизуйтесь заново.')
          console.error(error);
        });
      }

      
    }
  }
};
</script>

<style scoped>
.auth-block{
  display: flex;
  justify-content: center;
}

.auth-form{
  display: flex;
  width: 300px;
  flex-direction: column;
}

.auth-anime .auth-form input{
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  font-family: 'Exo 2', sans-serif;
  font-size: 18px;
}

.auth-anime .auth-form label{
  padding: 10px 0 5px 0;
  font-family: 'Montserrat', sans-serif;
}

.auth-anime .auth-form button{
  padding: 5px 10px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-family: 'Montserrat';
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
}

.auth-anime .auth-form .signin-button{
  color: white;
  background-color: #0d6efd;
}


</style>